// sagas.js
import { call, put, takeEvery, take, } from 'redux-saga/effects';
import {
  FETCH_ROLES_REQUEST,

  fetchRolesSuccess,

  fetchRolesFailure,

} from './actions';
import { api } from '../../api';

function* fetchRolesSaga(action) {
  try {
    const response = yield call(api.getRoles); // Pass the function and the args 
    yield put(fetchRolesSuccess(response.data));
  } catch (error) {
    yield put(fetchRolesFailure(error.message));
  }
}


export function* watchFetchRoles() {
  yield takeEvery(FETCH_ROLES_REQUEST, fetchRolesSaga);
}
